import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { TokenStorageService } from './token-storage.service';

@Injectable({
    providedIn: 'root'
})
export class CustomErrorHandler {

    handleError(response: HttpErrorResponse) {
        let errorMessage = '';
        if (response.status === 403) {
            let tokenStorage = new TokenStorageService();
            sessionStorage.setItem('tokenError', 'true');
            tokenStorage.signOut();
            window.location.href = "/login";
        }
        if (response.error.apierror) {
            errorMessage = response.error.apierror.message;
        } else if (response.error) {
            errorMessage = `Error: ${response.error.message}`;
        }
        else if (response.error instanceof ErrorEvent) {
            errorMessage = `Error: ${response.error.message}`;
        } else {
            errorMessage = `Error Code: ${response.status}\nMessage: ${response.message}`;
        }
        return throwError(errorMessage);
    }
}